import type { RichTextProps } from './RichText.types'
import cn from 'classnames'

import React from 'react'
import { sanitizeHTML } from '../../utils'
import styles from './RichText.module.css'

const tagClassMap: Partial<Record<keyof React.JSX.IntrinsicElements, string>> = {
  h1: styles.h1,
  h2: styles.h2,
  h3: styles.h3,
  h4: styles.h4,
  h5: styles.h5,
  h6: styles.h6,
  ul: styles.ul,
  a: styles.a,
  td: styles.td,
  th: styles.th,
}

const alignClassMap: Partial<Record<string, string>> = {
  center: styles.alignCenter,
  right: styles.alignRight,
}

export function RichText({ tag = 'div', children, className, verticalAlign = 'left', innerHTML }: RichTextProps) {
  const Tag = tag as React.ElementType
  const tagClass = tagClassMap[tag]
  const alignClass = alignClassMap[verticalAlign]

  if (innerHTML) {
    return (
      <Tag
        className={cn(styles.richText, tagClass, alignClass, className)}
        // eslint-disable-next-line react-dom/no-dangerously-set-innerhtml
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(innerHTML) }}
      />
    )
  }

  return (
    <Tag className={cn(styles.richText, tagClass, alignClass, className)}>
      {children}
    </Tag>
  )
}
